module.exports = __webpack_public_path__ + "static/media/cat-burglar.edac0a66.jpg";